import { QueryKey, useQuery } from 'react-query';
import { makeRequest } from '../../api/makeRequest';

interface UseGetItemQueryOptions {
    queryKey: string | any[];
    path: string;
    refetchInterval?: number;
}

export function useGetQuery<TResponse>({ queryKey, path, refetchInterval }: UseGetItemQueryOptions) {
    return useQuery<TResponse>(queryKey, () =>
        makeRequest({
            method: 'GET',
            path
        }),
        {
            refetchInterval: refetchInterval
        }
    );
}
